const createTypedEntry =
  <ValueType>() =>
  <K extends string>(storageKey: K) => ({ storageKey, value: undefined as ValueType });

// TODO remove any when types are provided
export const sessionStorageFields = {
  scpWidget: createTypedEntry<any>()('scpConfiguration'),
};
